var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"url":_vm.url,"bg-url":_vm.bgUrl,"bg-align":"left-top","content":_vm.content,"section":"社媒引流"}})
}
var staticRenderFns = []

export { render, staticRenderFns }